import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import GoogleHelmet from './components/Google';
// import FullStoryHelmet from './components/FullStory'; // DISABLING AS PART OF MODSY WIND DOWN WORK
import Postie from './components/Postie';
import SegmentHelmet from './components/Segment';
import Unbounce from './components/Unbounce';
import { authData, userIsLoggedIn } from 'redux/User';
import analytics from 'services/analytics';
import history from 'config/history';

export class AppHelmet extends Component {
  componentDidMount () {
    // Initialize Modsy Facebook Pixel
    // TODO: use app helmet to initialize FB pixel
    // need to listen for an onload event on fb pixel
    // to fire intitial tracking
    this.props.initializeFBPixel();

    this.props.initializeTTQPixel();

    // track initial pageview
    this.props.trackPageView({
      location: history.location,
      isInitialPageLoad: true
    });
  }

  render () {
    return [
      // Disable Google Analtyics/Optimize/Tags for local development.
      // If you need to test locally then just enable on a test branch.
      // process.env.NODE_ENV === 'development' ? null : <GoogleHelmet key='googleHelmet' />,
      // NOTE: re-enabling in dev mode so this can be easily testable while we move core
      // functionality to web-services. Once things look good we can consider disabling
      // again for local dev.
      <GoogleHelmet key='googleHelmet' />,

      <Postie key='postieHelmet' />,
      <SegmentHelmet key='segmentHelmet' />,
      <Unbounce key='unbounceHelmet' />,
      // <FullStoryHelmet
      //   key='fullStoryHelmet'
      //   userData={this.props.userData}
      //   userIsLoggedIn={this.props.userIsLoggedIn}
      // />,
      <Helmet key='mainHelment' title='Modsy'>
        {/* User info meta */}
        {this.props.userIsLoggedIn && (
          <meta content={JSON.stringify(this.props.userData)} id='user-info' name='user-info' />
        )}

        {/* Yahoo */}
        {process.env.REACT_APP_ENV === 'prod' && this.props.userIsLoggedIn && (
          <script type='application/javascript'>{`
            (function(w,d,t,r,u){w[u]=w[u]||[];w[u].push({'projectId':'10000','properties':{'pixelId':'10018588'}});var s=d.createElement(t);s.src=r;s.async=true;s.onload=s.onreadystatechange=function(){var y,rs=this.readyState,c=w[u];if(rs&&rs!="complete"&&rs!="loaded"){return}try{y=YAHOO.ywa.I13N.fireBeacon;w[u]=[];w[u].push=function(p){y([p])};y(c)}catch(e){}};var scr=d.getElementsByTagName(t)[0],par=scr.parentNode;par.insertBefore(s,scr)})(window,document,"script","https://s.yimg.com/wi/ytc.js","dotq");
          `}</script>
        )}

        <script src='https://use.typekit.net/ihr6jct.js' />
        <script type='application/javascript'>{`
          try{Typekit.load({ async: true });}catch(e){}
        `}</script>
      </Helmet>
    ];
  }
}

const mapStateToProps = state => ({
  userIsLoggedIn: userIsLoggedIn(state),
  userData: authData(state),
  location: state.router.location
});

const mapDispatchToProps = (dispatch) => ({
  initializeFBPixel: () => dispatch(analytics.initializeModsyFBPixel()),
  initializeTTQPixel: () => dispatch(analytics.initializeModsyTTQPixel()),
  trackPageView: (data) => dispatch(analytics.trackPageView(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(AppHelmet);
